import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-Already_done",
  "use": "icon-Already_done-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" viewBox=\"0 0 14 14\" id=\"icon-Already_done\"><g transform=\"matrix(1,0,0,-1,0,28)\"><path d=\"M7,14Q8.91406,14.0273438,10.5,14.929688Q12.0859,15.85938,13.0703,17.5Q14,19.16797,14,21Q14,22.83203,13.0703,24.5Q12.0859,26.1406,10.5,27.0703Q8.91406,27.9727,7,28Q5.08594,27.9727,3.5,27.0703Q1.91406,26.1406,0.929688,24.5Q0,22.83203,0,21Q0,19.16797,0.929688,17.5Q1.91406,15.85938,3.5,14.929688Q5.08594,14.0273438,7,14ZM10.0898,22.285159999999998L6.58984,18.78516L10.0898,22.285159999999998L6.58984,18.78516Q6.125,18.40234,5.66016,18.78516L3.91016,20.53516Q3.52734,21,3.91016,21.46484Q4.375,21.84766,4.83984,21.46484L6.125,20.17969L9.16016,23.214840000000002Q9.625,23.597659999999998,10.0898,23.214840000000002Q10.4727,22.75,10.0898,22.285159999999998Z\" fill=\"#4B5563\" fill-opacity=\"1\" style=\"mix-blend-mode:passthrough\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/Already_done.svg
// module id = ZS7Z
// module chunks = 119